import { BRAND_LIST, CountryLanguageSwitcher, DistanceUnit } from 'typings'
import * as Typings from '../typings'

const GreeceLocale: Typings.LocaleType = {
  IS_EU: true,
  REGION: Typings.RegionGroupNames.OTHER,
  CODE: 'GR',
  LANGUAGE_CODE: 'en',

  LONG_NAME: 'Greece',
  SHORT_NAME: 'GR',

  DISPLAY_NAME: 'Greece (English)',
  DISPLAY_COUNTRY: 'Greece (English)',

  GEO_COORDINATES: {
    INITIAL_LATITUDE: 38.0359305,
    INITIAL_LONGITUDE: 19.0377454,
    INITIAL_ZOOM: 5,
    INITIAL_ZOOM_DETAILS_PAGE: 15,
  },

  AREAS: {
    '1': 'Attica',
    '2': 'Central Greece',
    '3': 'Central Macedonia',
    '4': 'Crete',
    '5': 'Eastern Macedonia and Thrace',
    '6': 'Epirus',
    '7': 'Ionian Islands',
    '8': 'Mount Athos',
    '9': 'North Aegean',
    '10': 'Peloponnese',
    '11': 'South Aegean',
    '12': 'Thessaly',
    '13': 'Western Greece',
    '14': 'Western Macedonia',
  },

  HOME_PAGE_URL: 'https://www.uniqlo.com/eu-gr/en/',

  MAP_MOBILE_URL: 'https://map.uniqlo.com/eu-gr/en/',

  CONTACT_US_URL: 'https://faq-eu.uniqlo.com/',
  TERMS_OF_USE_URL:
    'https://faq-eu.uniqlo.com/pkb_Home_UQ_EU?l=en&c=category_uq_eu_dk_se%3ARenew_UQEU_C7_3',
  PRIVACY_POLICY_URL:
    'https://faq-eu.uniqlo.com/pkb_Home_UQ_EU?l=dk&c=category_uq_eu_dk_se%3ARenew_UQEU_C7_2',

  POSTCODE_FORMAT: /^[0-9]{5}$/,

  CLIENT_ID: {
    [BRAND_LIST.UQ]: '',
  },

  DISTANCE_UNIT: DistanceUnit.KM,

  SHOW_COUNTRY_LANGUAGE_MODAL: {
    [BRAND_LIST.UQ]: CountryLanguageSwitcher.HEADER_SWITCHER_MODAL,
    [BRAND_LIST.GU]: CountryLanguageSwitcher.ALL_DISABLED,
    [BRAND_LIST.PL]: CountryLanguageSwitcher.ALL_DISABLED,
  },

  ONE_TRUST_FOOTER: {
    [BRAND_LIST.UQ]: true,
  },
}

export default GreeceLocale
